module.exports = __webpack_public_path__ + "img/img_title_qijiandian_active.fc085e02.png";